// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingInfo_container__2ASo9","loading":"LoadingInfo_loading__29KNt","spin":"LoadingInfo_spin__v1lYj"};